<template>
  <div>
    <div class="main-title">舆情配置</div>
    <el-row class="content-container">
      <div class="table-container">
        <el-table :data="dataList" style="width: 100%">
          <el-table-column type="index" label="序号" />
          <el-table-column prop="grabAreas" label="抓取区域" />
          <el-table-column prop="grabLoginUrl" label="系统登录URL" />
          <el-table-column prop="grabUrl" label="抓取地址" />
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button type="text" @click="handleClick(scope.row)"
                >编辑</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :current-page.sync="currentPage"
          :page-sizes="pageSizes"
          :page-size="pageSize"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-row>
    <el-dialog title="舆情配置修改" :visible.sync="dialogVisible" width="800px">
      <el-form label-width="100px">
        <el-row>
          <el-col :span="11">
            <el-form-item label="抓取登录地址">
              <el-input
                placeholder="请输入抓取登录地址"
                v-model="configInfo.grabLoginUrl"
              />
            </el-form-item>
          </el-col>
          <el-col :span="11" :offset="1">
            <el-form-item label="抓取密码">
              <el-input
                placeholder="请输入抓取密码"
                type="password"
                v-model="configInfo.grabPassword"
              />
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="抓取地址">
              <el-input
                placeholder="请输入抓取地址"
                v-model="configInfo.grabUrl"
              />
            </el-form-item>
          </el-col>
          <el-col :span="11" :offset="1">
            <el-form-item label="抓取用户名">
              <el-input
                placeholder="请输入抓取用户名"
                v-model="configInfo.grabUserName"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="抓取区域">
              <el-checkbox-group v-model="checkedAreas">
                <el-checkbox
                  v-for="item in allAreas"
                  :label="item.area_desc"
                  :key="item.area_desc"
                  >{{ item.area_desc }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="submit">确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import paginationMixin from 'mixin/pagination';
export default {
  data() {
    return {
      dialogVisible: false,
      allAreas: [],
      checkedAreas: [],
      dataList: [],
      configInfo: {
        grabAreas: '',
        grabLoginUrl: '',
        grabPassword: '',
        grabUrl: '',
        grabUserName: '',
        id: ''
      }
    };
  },
  mixins: [paginationMixin],
  mounted() {
    this.loadAreas();
    this.querySubmit();
  },
  methods: {
    loadAreas() {
      this.$request({
        url: 'rest/statistic/reportData',
        data: {
          json: JSON.stringify({
            dict: {},
            pageBean: {
              pageNum: 1,
              pageSize: 100
            },
            params: {
              handlerName: 'grab_areas'
            }
          })
        }
      }).then(res => {
        this.allAreas = res ? [...res.list] : [];
      });
    },
    querySubmit() {
      this.$request({
        url: 'rest/statistic/reportData',
        data: {
          json: JSON.stringify({
            dict: {},
            pageBean: {
              pageNum: this.currentPage,
              pageSize: this.pageSize
            },
            params: {
              handlerName: 'grab_config_info'
            }
          })
        }
      }).then(res => {
        this.dataList = res ? [...res.list] : [];
        this.total = res ? res.total : 0;
      });
    },
    handleClick(row) {
      this.$request({
        url: 'rest/statistic/reportData',
        data: {
          json: JSON.stringify({
            dict: {},
            pageBean: {
              pageNum: 1,
              pageSize: 1
            },
            params: {
              handlerName: 'grab_config_info',
              id: row.id
            }
          })
        }
      }).then(res => {
        for (const key in this.configInfo) {
          this.configInfo[key] = res.list[0][key];
        }
        const grabAreas = res.list[0].grabAreas;
        this.checkedAreas =
          grabAreas.indexOf(',') > -1 ? grabAreas.split(',') : [grabAreas];
        this.dialogVisible = true;
      });
    },
    submit() {
      this.$request({
        url: 'rest/grab/config/update',
        data: {
          json: JSON.stringify({
            dict: {},
            params: {
              ...this.configInfo,
              grabAreas: this.checkedAreas.join(',')
            }
          })
        }
      }).then(res => {
        this.$message({
          message: '保存成功',
          type: 'success'
        });
        this.dialogVisible = false;
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
@import './common.styl'
.pagination
  padding 20px
  background #fff
  text-align right
</style>
